import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Grid } from '@mui/material';

import { AnalyticsMetadataType } from 'graphql/types';
import SuperVisorSourceByTimeChart from '../components/SourceByTimeChart/SuperVisorSourceByTimeChart';
import SupervisorClientChart from '../components/TimeSheetLabelCharts/SupervisorClientChart';
import SupervisorProjectChart from '../components/TimeSheetLabelCharts/SupervisorProjectChart';
import SupervisorUtilizationChart from '../components/UtilizationChart/SupervisorUtilizationChart';
import SupervisorTaskChart from '../components/TimeSheetLabelCharts/SupervisorTaskChart';
import OEFChartContextProvider from '../components/TimeSheetLabelCharts/OEFCharts/OEFChartContextProvider';
import OEFSupervisorChartContainer from '../components/TimeSheetLabelCharts/OEFCharts/OEFSupervisorChartContainer';
import TeamChart from '../components/MyTeamChart/TeamChart';
import SupervisorProgramChart from '../components/TimeSheetLabelCharts/SupervisorProgramChart';
import TeamProductivityChart from '../components/TeamProductivityChart/TeamProductivityChart';
import SupervisorActivityChart from '../components/TimeSheetLabelCharts/SupervisorActivityChart';
import { useSupervisorInsightContext } from './SupervisorInsightContextProvider';
import { useLabelVisibility } from './hooks/useLabelVisibility';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column'
  },
  itemContainer: {
    width: '55%',
    marginTop: theme.spacing(2)
  },
  itemClassification: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
  },

  rightDiv: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  labelChartGrid: {
    marginTop: theme.spacing(2)
  },
  lowerDiv: {
    display: 'flex'
  }
}));
const SupervisorInsights: React.FC = () => {
  const classes = useStyles();
  const { currentPeriod } = useSupervisorInsightContext();
  const labelVisibility = useLabelVisibility(currentPeriod!);

  return (
    <React.Fragment>
      <div className={classes.container}>
        <div>
          <TeamProductivityChart />
          <div className={classes.itemClassification}>
            <TeamChart />
            <SupervisorUtilizationChart />
          </div>
        </div>
        <div className={classes.lowerDiv}>
          <div className={classes.rightDiv}>
            <Grid container className={classes.labelChartGrid}>
              <Grid item xs={4}>
                {labelVisibility.PROGRAM ? (
                  <SupervisorProgramChart />
                ) : (
                  <SupervisorClientChart />
                )}
              </Grid>
              <Grid item xs={4}>
                <SupervisorProjectChart />
              </Grid>
              <Grid item xs={4}>
                <SupervisorTaskChart />
              </Grid>
              <Grid container>
                <Grid item xs={4}>
                  <SupervisorActivityChart />
                </Grid>
                <OEFChartContextProvider
                  insightContext={useSupervisorInsightContext}
                  AnalyticsMetadataInput={
                    AnalyticsMetadataType.MetadataSupervisorOefList
                  }
                >
                  <OEFSupervisorChartContainer />
                </OEFChartContextProvider>
              </Grid>
            </Grid>
          </div>

          <div className={classes.itemContainer}>
            <SuperVisorSourceByTimeChart />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(SupervisorInsights);
